import type { Organization } from '../types'
import type { APIResponse } from '@/shared/types'
import { apiService, API_ENDPOINTS } from '@/shared/services'

export class OrganizationService {
  /**
   * Get all organizations
   */
  static async getOrganizations(): Promise<APIResponse<Organization[]>> {
    try {
      const response = await apiService.get('/hr/organizations')
      return response.data
    } catch (error: any) {
      console.error('Error fetching organizations:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch organizations')
    }
  }

  /**
   * Get organization hierarchy
   */
  static async getOrganizationHierarchy(): Promise<APIResponse<Organization[]>> {
    try {
      const response = await apiService.get('/hr/organizations/hierarchy')
      return response.data
    } catch (error: any) {
      console.error('Error fetching organization hierarchy:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch organization hierarchy')
    }
  }

  /**
   * Get organization by ID
   */
  static async getOrganizationById(id: string): Promise<APIResponse<Organization>> {
    try {
      const response = await apiService.get(`/hr/organizations/${id}`)
      return response.data
    } catch (error: any) {
      console.error('Error fetching organization:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch organization')
    }
  }

  /**
   * Get organizations accessible to a specific organization
   */
  static async getOrganizationsAccessibleTo(organizationId: string): Promise<APIResponse<Organization[]>> {
    try {
      const response = await apiService.get(`/campaigns/accessible-to-organization/${organizationId}`)
      return response.data
    } catch (error: any) {
      console.error('Error fetching accessible organizations:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch accessible organizations')
    }
  }

  /**
   * Get organizations by level (EM, DM, CM, BM, AM, M)
   */
  static async getOrganizationsByLevel(level: string): Promise<Organization[]> {
    try {
      const response = await apiService.get<APIResponse<Organization[]>>(`${API_ENDPOINTS.hr.organizationsByLevel}/${level}`)
      return response.data.data || []
    } catch (error: any) {
      console.error('Error fetching organizations by level:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch organizations by level')
    }
  }
}

export default OrganizationService
